// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".immersive3dTourEditionPlayer {\n  position: relative;\n  z-index: 1;\n  min-height: 800px;\n  margin: 1em 0;\n  width: 100%;\n  border: none;\n}\n", ""]);
// Exports
module.exports = exports;
